import { render, staticRenderFns } from "./expire-password.vue?vue&type=template&id=51a84942"
import script from "./expire-password.vue?vue&type=script&lang=js"
export * from "./expire-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports